<h2 mat-dialog-title>{{ data.title || 'Confirm Action' }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="warn" (click)="onYesClick()">Confirm</button>
</mat-dialog-actions> 